import Vue from 'vue'
import teamTransformer from './../../transformers/team'
import store from './../../store'

// When the request succeeds
const success = (team) => {
  team = teamTransformer.fetch(team)

  store.dispatch('getTeam', team)
  store.dispatch('setPage', {
    title: team.title_sport,
    subtitle: team.title_year,
  })
}

// When the request fails
const failed = () => {
}

export default (teamId) => {
  Vue.http.get(`media/?id=${teamId}`)
    .then(response => response.json())
    .then(success)
    .catch(failed)
}
